import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { getTimestamp } from '../../../../utils/dateParser'
import { Button } from '../../../../components/Button'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { RemindersContext } from '../../context'
import { EDIT_FORM } from '../Form/formModes'

export const Reminder = ({ reminder }) => {
  const {
    actions: { goToForm, goToDestroy }
  } = useContext(RemindersContext)

  return (
    <Box
      display='flex'
      justifyContent='space-between'
      className='wealth-manager-reminders__reminder'
      mb='0.5rem'
      p='0.3rem'
    >
      <Box
        className='wealth-manager-reminders__reminder__description'
        width='14rem'
        textAlign='left'
      >
        <p>{reminder.description}</p>
      </Box>
      <Box
        className='wealth-manager-reminders__reminder__actions toggle'
      >
        <Button
          component='span'
          className='wealth-manager-reminders__reminder__actions__button'
          trackAs='Reminder: Edit Reminder'
          onClick={goToForm(EDIT_FORM, reminder)}
        >
          <EditIcon />
        </Button>
        <Button
          component='span'
          className='wealth-manager-reminders__reminder__actions__button'
          trackAs='Reminder: Delete Reminder'
          onClick={goToDestroy(reminder)}
        >
          <DeleteIcon />
        </Button>
      </Box>
      <Box className='wealth-manager-reminders__reminder-dates'>
        <Box className='wealth-manager-reminders__reminder__remind-date'>
          <p>{getTimestamp(reminder.remind_at, { dateOnly: true }) || ''}</p>
        </Box>
        <Box className='wealth-manager-reminders__reminder__due'>
          <p>{getTimestamp(reminder.due_at, { dateOnly: true }) || ''}</p>
        </Box>
      </Box>
    </Box>

  )
}
